/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
  "aws_project_region": "eu-west-1",
  "aws_cloud_logic_custom": [
    {
      "name": "AdminQueries",
      "endpoint": "https://wbqr7s4jpd.execute-api.eu-west-1.amazonaws.com/prod",
      "region": "eu-west-1"
    }
  ],
  "aws_appsync_graphqlEndpoint": "https://4ypinpc2nbb2ldor6zdesze4ye.appsync-api.eu-west-1.amazonaws.com/graphql",
  "aws_appsync_region": "eu-west-1",
  "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
  "aws_cognito_identity_pool_id": "eu-west-1:43f6f246-1f6c-4671-bb71-73ebcfcd1adc",
  "aws_cognito_region": "eu-west-1",
  "aws_user_pools_id": "eu-west-1_JbjE4AnCF",
  "aws_user_pools_web_client_id": "4khbua4l24sob0ib4rnr918g25",
  "oauth": {},
  "aws_cognito_username_attributes": [
    "EMAIL"
  ],
  "aws_cognito_social_providers": [],
  "aws_cognito_signup_attributes": [
    "EMAIL",
    "FAMILY_NAME",
    "GIVEN_NAME"
  ],
  "aws_cognito_mfa_configuration": "OFF",
  "aws_cognito_mfa_types": [
    "SMS"
  ],
  "aws_cognito_password_protection_settings": {
    "passwordPolicyMinLength": 8,
    "passwordPolicyCharacters": []
  },
  "aws_cognito_verification_mechanisms": [
    "EMAIL"
  ],
  "aws_user_files_s3_bucket": "version2userdatac8dff-prod",
  "aws_user_files_s3_bucket_region": "eu-west-1"
};

export default awsmobile;
